module.exports = __webpack_public_path__ + "static/img/SEAT.953ef29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/SEAT.png
// module id = hwc5
// module chunks = 1